import type { Accessor, Component } from "solid-js";
import { useI18n } from "@/api/i18n";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useLeaveConfirmation } from "../hooks/useLeaveConfirmation";

type LeaveConfirmationDialogProps = {
  when: Accessor<boolean>;
  onConfirm: () => void;
  excludedRoutes?: string[];
};

export const LeaveConfirmationDialog: Component<
  LeaveConfirmationDialogProps
> = (props) => {
  const { t } = useI18n();
  const { pendingLeave, handleLeaveConfirm, handleLeaveCancel } =
    useLeaveConfirmation({
      when: props.when,
      onConfirm: props.onConfirm,
      excludedRoutes: props.excludedRoutes,
    });

  return (
    <Dialog
      open={pendingLeave() !== null}
      onOpenChange={(open) => !open && handleLeaveCancel()}
    >
      <DialogContent class="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t("common.back_confirm_dialog.title")}</DialogTitle>
          <DialogDescription>
            {t("common.back_confirm_dialog.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter class="gap-2 sm:gap-0">
          <Button variant="outline" onClick={handleLeaveCancel}>
            {t("common.back_confirm_dialog.cancel")}
          </Button>
          <Button variant="destructive" onClick={handleLeaveConfirm}>
            {t("common.back_confirm_dialog.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
